import {createContext, use} from 'react'
import type {AgentProfile} from '../agents/agent-profile'
import {DEFAULT_PROFILE} from '../agents/agent-profile'

export const AgentProfileContext = createContext<AgentProfile>(DEFAULT_PROFILE)

/**
 * Returns the current agent profile from context.
 * Falls back to DEFAULT_PROFILE if no provider is present (safe for gradual adoption).
 */
export function useAgentProfile(): AgentProfile {
  return use(AgentProfileContext)
}
